// extracted by mini-css-extract-plugin
export default {"main":"AdminMain_main__V0Dzi","aside":"AdminMain_aside__PP0IM","article":"AdminMain_article__ps5a+"};